import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalSendTicketsAdminComponent } from 'src/app/modals-admin/modal-send-tickets-admin/modal-send-tickets-admin.component';
import { AuthService } from 'src/app/services/auth.service';
import { EventsService } from 'src/app/services/events.service';
import { StorageService } from 'src/app/services/storage.service';
import { TicketsService } from 'src/app/services/tickets.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-send-ticket-friend-modal',
  templateUrl: './send-ticket-friend-modal.component.html',
  styleUrls: ['./send-ticket-friend-modal.component.scss'],
})
export class SendTicketFriendModalComponent implements OnInit {
  loading: any = true;
  ticket: any;
  emailFriend: any = '';
  friends: any = [];
  user: any = {};

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private ticketsService: TicketsService,
    private dialogRef: MatDialogRef<ModalSendTicketsAdminComponent>,
    private authService: AuthService,
    private storageService: StorageService
  ) {}

  ngOnInit() {
    this.loading = false;
    this.ticket = this.data.ticket;

    this.user = this.authService.getUser();
    this.friends = this.user.frequentFriends || [];

    console.log(this.friends);
  }

  closeDialog(action: any) {
    this.dialogRef.close(action);
  }

  async sendTicketToFriend() {
    (
      await this.ticketsService.sendTicketToFriend(
        this.ticket.id,
        this.emailFriend
      )
    ).subscribe((data) => {
      if (data.result) {
        this.loading = false;

        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Ticket enviado.',
          text:
            'El ticket fue enviado de manera correcta a ' + this.emailFriend,
          showConfirmButton: false,
          timer: 1500,
        });

        this.user.frequentFriends =
          this.user.frequentFriends === undefined
            ? []
            : this.user.frequentFriends;

        this.user.frequentFriends = [
          ...this.user.frequentFriends,
          this.emailFriend,
        ];

        this.storageService.setStorageItem({
          key: 'users',
          value: `${JSON.stringify({ ...this.user })}`,
          storageArea: 'sessionStorage',
        });

        this.closeDialog(true);
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: data.message,
          text: data.code,
          showConfirmButton: false,
          timer: 1500,
        });
      }
    });
  }

  clickFriend(friend: any) {
    this.emailFriend = friend;
  }
}
